module.exports = __webpack_public_path__ + "img/live_weixin1.1005007e.png";